export const standardFilterFields = [
	'fpcJobId',
	//
	'countryCode',
	'organizationId',
	'projectId',
	'customerId',
	//
	'jobId',
	//
	'createdBy',
	// 'createdAt',
	//
	'status',
] as const;

export const dateFilterFields = ['createdAt'] as const;

export const filterFields = [...standardFilterFields, ...dateFilterFields] as const;
